import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MultiFactorAuthentication } from "components/Common/MultiFactorAuthentication";
import { WizardLink } from "components/Common/WizardLink";
import { ACCOUNT_PATH, IDENTITY_PATH } from "helperFunctions/paths";
import { FormattedMessage, useIntl } from "react-intl";
/* The Dashboard "Advanced Settings" tab */
export function Security() {
    const intl = useIntl();
    return (_jsxs(_Fragment, { children: [_jsxs("section", { className: "intro", children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "common.security", description: "security main title", defaultMessage: "Security" }) }), _jsx("div", { className: "lead", children: _jsx("p", { children: _jsx(FormattedMessage, { id: "security.title", description: "security lead title", defaultMessage: "Enhance and manage the security of your eduID." }) }) })] }), _jsx(MultiFactorAuthentication, {}), _jsx(WizardLink, { previousLink: IDENTITY_PATH, previousText: intl.formatMessage({
                    id: "security.identity",
                    defaultMessage: "To Identity Settings",
                }), nextLink: ACCOUNT_PATH, nextText: intl.formatMessage({
                    id: "security.account",
                    defaultMessage: "To Account Settings",
                }) })] }));
}
